import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pp_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem("pp_token", data.token);
        return api(cfg);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("pp_token");
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export async function download(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

const brlFmt = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
export const brl = (v) => brlFmt.format(Number(v || 0));
export const brlShort = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e6) return `R$ ${(n / 1e6).toFixed(1).replace(".", ",")} mi`;
  if (Math.abs(n) >= 1e3) return `R$ ${(n / 1e3).toFixed(0)} mil`;
  return brl(n);
};
export const pct = (v) => `${Number(v || 0).toFixed(1).replace(".", ",")}%`;
export const dateBR = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "—");
export const today = () => new Date().toISOString().slice(0, 10);
export const KIND_LABEL = { pessoa: "Pessoa Física", familia: "Família", autonomo: "Autônomo", empresa: "Empresa (PJ)" };
